/********************************************************************************
Filename: np-select-option.js
Created: 13 Apr 2021
Author: Ron Robertson
Description: Option component to go with np-select
Usage Example:
<np-select>
    <np-select-option value="1" selected>Option One</np-select-option>
    <np-select-option value="2">Option Two</np-select-option>
    <np-select-option value="3">Option Three</np-select-option>
</np-select>
********************************************************************************/

(function() {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
            #np-select-option {
                padding: 8px 10px;
                font-size: var(--bodyFontSize);
            }
            #np-select-option:hover {
                background-color: #e4e4e4;
                cursor: default;
            }


        </style>

        <div id="np-select-option">
            <slot></slot>
        </div><!--END np-select-option-->
    `;

    class NpSelectOption extends HTMLElement {
        constructor() {
            /* Always call super first in constructor */
            super();

            /* bind 'this' to class in the method */
            this.selectedEvent = this.selectedEvent.bind(this);

            /* Use the Shadow DOM */
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.npSelectOption = this.shadowRoot.getElementById("np-select-option");

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {

            /* Set default attribute value */
            if (!this.hasAttribute('value')) {
                this.setAttribute('value', "");
            }

            /* Set Event Listeners */
            this.npSelectOption.addEventListener('click', this.selectedEvent);

        } /* END connectedCallback */

        /* Listen for when attributes change */
        /* attributes must be lowercase */
        static get observedAttributes() {
            return ['value','selected','hidden'];
        }

      /* Called when attributes change */
      attributeChangedCallback(name, oldValue, newValue) {

        if(name === 'value') {
            /* do something when value changes */
        }
        if(name === 'hidden'){
            if(newValue =="true"){
                this.npSelectOption.style.display = "none";
            }else{
                this.npSelectOption.style.display = "block";
            }
        }
        if(name === 'selected'){

            /* Dispatch the event */
            this.dispatchEvent(new CustomEvent('selected',{bubbles:true, composed:true}));
        }
       }/* END attributesChangedCallback */

      /* Getting attributes */
      get value() {
        return this.getAttribute('value');
      }
      get selected() {
        return this.getAttribute('selected');
      }
      get hidden() {
          return this.getAttribute('hidden');
      }

      /* Settinng attributes */
      set value(newValue) {
        this.setAttribute('value', newValue);
      }
      set selected(newValue) {
        this.setAttribute('selected', newValue);
      }
      set hidden(newValue){
          this.setAttribute('hidden', newValue);
      }

      /* Called when removed from DOM */
      disconnectedCallback() {

        /* Removing event listeners */
        this.npSelectOption.removeEventListener('click', this.clickEvent);
      }

        /*** Methods ***/

        /* When the option is selected */
        selectedEvent() {
            this.setAttribute('selected','');
        }

    } /* END class */

    window.customElements.define('np-select-option', NpSelectOption);

  })();
